import BackendService from './BackendService';

export default class SoftCreditPullService {
  static getReportUrl(dealId: string): Promise<{ data: { url: string } }> {
    return BackendService.get(`/softcreditpull/${dealId}/report-url`);
  }
}
